export default "__VITE_ASSET__BEPmGLa7__"